import cognitoAuth from '@/cognito'
import store from '@/store'

export const authHelpers = {
  logoutAndClearStore () {
    cognitoAuth.logout()
    store.commit('logout')
  }
}

export const hexToUtf8 = (hex) => {
  return decodeURIComponent(hex.replace(/(..)/g, '%$1'))
}

export const parseAuthCustomState = (encodedState) => {
  if (!encodedState) {
    return null
  }

  try {
    // Extract the JSON-like hex part
    const hexMatch = encodedState.match(/([0-9a-fA-F]{20,})$/)

    if (!hexMatch) {
      return null
    }

    const hexString = hexMatch[1]

    // Convert from hex to readable JSON
    const jsonString = hexToUtf8(hexString)
    return JSON.parse(jsonString)
  } catch (error) {
    console.error('Failed to parse state:', error)
  }
}
